/*
 * File: c:\Users\j.mazat\Desktop\mobifleet_front\src\Content\Login\Form\Form.tsx
 * Project: c:\Users\j.mazat\Desktop\mobifleet_front
 * Created Date: Monday April 29th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday April 29th 2024 2:29:15 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import React, { useEffect, useState } from "react";
import Styles from "Content/Login/Form/FormLogin.module.css";
import RouterPathResolver from "Config/Router/RouterPathResolver";
import UserService from "Services/Users/UserService";
import { useNavigate } from "react-router-dom";
import Input from "Theme/Component/Input";
import InputSubmit from "Theme/Component/InputSubmit";
import Alert from "react-bootstrap/Alert";
import translator from "MultiLanguage/TranslationWrapper";
import ServiceGeneral from 'Services/ServiceGeneral';
import { useAuth } from "Router/AuthProvider";

type FormLoginPropsType = {
    returnUrl?: string | null
};

/**
 * Hook for the Form component of the login component
 * @param {Object} props The props passed to the component
 */
function FormLogin(props: FormLoginPropsType) {
    const [username, setName] = useState("");
    const [password, setPassword] = useState("");
    const [loginError, setLoginError] = useState(false);
    const [isEnable, setIsEnable] = useState(false);
    const navigate = useNavigate();
    const return_url = props.returnUrl;
    const { login } = useAuth();

    useEffect(() => {
        if (username && password)
            setIsEnable(true);
        else
            setIsEnable(false);
    }, [username, password]);

    /**
     * Handle submission of the form
     * @param {*} event The event object triggered when form submitted
     */
    const HandleSubmit =  async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const response = await UserService.login(username, password, true);
        ServiceGeneral.handleAxiosResponse(response);

        if (response.status !== 200 && response.status !== 304) {
            login(false);
            setLoginError(response.data.message);
        } else if (return_url !== undefined && return_url !== null) {
            login(true);
            navigate(return_url);
        } else {
            login(true);
            navigate(RouterPathResolver.pathEntryPoint.path);
        }
    };

    return (
        <div id={Styles.div_form} className={"padded medium-round-border"}>
            <form className={"margined block"} onSubmit={HandleSubmit}>
                {loginError ?
                    <Alert variant="danger" className="margined block">
                        {translator.decode("login.error_message")}
                    </Alert>
                    :null
                }
                <Input
                    id="username"
                    type="text"
                    className={"block h-center-div full-width " + Styles.input}
                    variant="none"
                    value={username}
                    placeholder={translator.decode("login.placeholder.username")}
                    onChange={(e: React.FormEvent<HTMLInputElement>) => {setName(e.currentTarget.value)}}
                />
                <Input
                    id="password"
                    className={"block h-center-div full-width margin-bottom " + Styles.input}
                    type="password"
                    variant="none"
                    value={password}
                    placeholder={translator.decode("login.placeholder.password")}
                    onChange={(e: React.FormEvent<HTMLInputElement>) => setPassword(e.currentTarget.value)}
                />
                <InputSubmit
                    disabled = {!isEnable}
                    className={"block h-center-div full-width font-weight-700 large-font-2 margin-bottom " + Styles.input_submit}
                    value={translator.decode("login.send")}
                />
            </form>
        </div>
    );
}

export default FormLogin;
